
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2019',
  depVersions: {
  "customer-portal-app": "static-1.2019",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.457",
  "data-fetching-client": "static-1.9592",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.428",
  "growth-payments-core": "static-1.25119",
  "head-dlb": "static-1.4938",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5511",
  "hs-test-utils": "static-1.7929",
  "hub-http": "static-1.6138",
  "hub-http-shared-msw-handlers": "static-1.9773",
  "hubspot-dlb": "static-2.1832",
  "hubspot-prosemirror": "static-1.17995",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11376",
  "I18n": "static-7.1605",
  "immutable": "static-2.77",
  "jasmine-runner": "static-1.6384",
  "payment-link-components": "static-1.23290",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6895",
  "quartz-core": "static-1.6114",
  "react": "static-7.184",
  "react-colorpicker": "static-2.10126",
  "react-dlb": "static-1.77",
  "react-utils": "static-2.5276",
  "rich-text-lib": "static-1.19689",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17866",
  "ui-components-test-utils": "static-1.5514",
  "UIComponents": "static-3.8323",
  "foundations-assets": "static-1.4768",
  "foundations-components": "static-1.7765",
  "foundations-theming": "static-1.4331",
  "foundations-theming-specialty": "static-1.2047",
  "framer-motion": "static-1.70",
  "history": "static-4.47",
  "metrics-js": "static-1.9542",
  "PortalIdParser": "static-2.388",
  "portals-platform-lib": "static-1.733",
  "quartz-config": "static-1.673",
  "quartz-routing": "static-1.325",
  "quick-fetch": "static-1.3849",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16576",
  "react-router-dom": "static-5.26",
  "rpc-client-utils": "static-1.4561",
  "sanitize-text": "static-1.8061",
  "styled-components": "static-2.88",
  "tanstack-table": "static-1.53",
  "ui-addon-draggable": "static-3.4685",
  "ui-addon-react-router-dom": "static-1.9461",
  "usage-tracker": "static-1.7253",
  "usage-tracker-anonymous": "static-1.5670",
  "usage-tracker-core": "static-1.7103",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3335",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3172",
  "quartz-webpack": "static-1.3119",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.80",
  "customer-data-objects": "static-1.7576",
  "frontend-preferences-client": "static-1.7842",
  "laboratory-lib": "static-3.7075",
  "onboarding-scopes": "static-1.6381",
  "ui-addon-opt": "static-4.8297",
  "HeadJS": "static-2.736",
  "hs-test-utils-bend-plugin": "static-1.3040",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "hs-locale-management": "static-1.17",
  "ts-schema": "static-1.4011",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7629",
  "cssUtils": "static-1.772",
  "customer-data-ui-utilities": "static-1.9743",
  "HubStyle": "static-2.11684",
  "knowledge-content-types": "static-1.8462",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.570",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.485",
  "ui-addon-emoji-picker": "static-1.9803",
  "ui-addon-i18n": "static-1.11066",
  "ui-business-units-lib": "static-1.8958",
  "ui-shepherd-react": "static-3.10065",
  "video-components-external": "static-1.11003",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4240",
  "commerce-tours-lib": "static-1.5942",
  "customer-data-properties": "static-1.51250",
  "getting-started-shared-tasks": "static-1.18262",
  "growth-onboarding-reliability": "static-1.5001",
  "onboarding-tours": "static-1.16447",
  "reference-resolvers-lite": "static-1.8008",
  "sales-checkout-service-client": "static-1.3569",
  "ui-addon-iframeable": "static-1.8967",
  "user-context": "static-1.5017",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.820",
  "hubspotter-http": "static-1.4585",
  "icons": "static-2.639",
  "mobile-manifest-mixins": "static-1.510",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.570",
  "quartz-head": "static-1.560",
  "quartz-test": "static-1.570",
  "quartz-tracking": "static-1.274",
  "ui-fonts": "static-1.638",
  "usage-tracker-container": "static-1.7243",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9347",
  "data-token-picker": "static-1.16259",
  "FileManagerLib": "static-1.38998",
  "property-translator": "static-1.5322",
  "atom": "static-1.4987",
  "merchandise-lib": "static-1.262",
  "purchase-motions-components": "static-1.5718",
  "salesImages": "static-1.523",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5248",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.97",
  "ui-images": "static-2.1132",
  "bend-plugin-foundations-components": "static-1.4035",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "trellis-assets": "static-1.1578",
  "bend-plugin-foundations-theming": "static-1.2814",
  "foundations-theming-base": "static-1.3316",
  "stylex": "static-1.30",
  "interframe": "static-3.4679",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5667",
  "chirp-fetch": "static-1.1799",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4389",
  "react-flip-move": "static-1.68",
  "bender-build-tools": "static-1.3093",
  "inbound-db-properties-service-client": "static-1.3776",
  "superstore": "static-1.4685",
  "feedback-loader": "static-1.29145",
  "ai-components-ui-library": "static-1.8731",
  "ui-addon-video-player": "static-1.8613",
  "ui-coaching-tips": "static-1.28307",
  "sassPrefix": "static-1.154",
  "react-dnd-compat": "static-1.4536",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2410",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8085",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4567",
  "content-media-composition-data-lib": "static-1.11990",
  "content-media-compositions": "static-2.15997",
  "idb-keyval": "static-1.42",
  "immer": "static-1.33",
  "immerable": "static-1.4069",
  "magpie-lib": "static-1.5511",
  "magpie-types": "static-1.4971",
  "media-bridge-lib": "static-1.18781",
  "video-data-lib": "static-1.34661",
  "commerce-products-lib": "static-1.9216",
  "crm-message-bus": "static-1.42755",
  "growth-data-modal": "static-1.5299",
  "hubspot-apollo-client": "static-1.4794",
  "onboarding-tours-client": "static-1.4661",
  "calling-global-api": "static-1.64176",
  "calling-internal-common": "static-1.31218",
  "calling-lifecycle-internal": "static-1.65558",
  "calling-lifecycle-messages": "static-1.57852",
  "conditional-properties-service-client": "static-1.3730",
  "crm-links": "static-1.6195",
  "customer-data-objects-ui-components": "static-1.12938",
  "customer-data-properties-shared-msw-handlers": "static-1.9100",
  "customer-data-property-utils": "static-1.8001",
  "external-options-client-types": "static-1.4091",
  "file-manager-components": "static-1.23358",
  "framework-data-schema-resolvers": "static-1.6791",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.57",
  "inbound-db-meta-service-client": "static-1.3523",
  "inbounddb-objects-service-types": "static-1.4156",
  "meetings-icalendar-utils-lib": "static-1.546",
  "multi-currency-client-types": "static-1.3624",
  "object-builder-ui-client": "static-1.48460",
  "pipeline-validation-client-types": "static-1.3899",
  "property-value-citations": "static-1.1864",
  "pulse": "static-1.464",
  "smart-property-lib": "static-1.6507",
  "tiered-pricing": "static-1.1038",
  "ui-addon-form-validation": "static-1.10907",
  "growth-onboarding-confetti": "static-1.2987",
  "growth-onboarding-next-action-utils": "static-1.1669",
  "navigation-components": "static-1.17724",
  "onboarding-tours-utils": "static-1.513",
  "ui-shepherd-tracker": "static-1.7446",
  "ui-universal-auth": "static-1.8869",
  "batch-promise": "static-1.1469",
  "navigation-messaging": "static-1.7051",
  "getting-started-shared-tasks-store": "static-1.17380",
  "hubspotter-http-shared-msw-handlers": "static-1.9771",
  "usage-tracker-session-replay": "static-1.4939",
  "audio-components": "static-1.5791",
  "FileManagerCore": "static-1.38857",
  "FileManagerImages": "static-1.36509",
  "video-components": "static-1.13006",
  "foundations-components-legacy": "static-1.790",
  "nav-client-types": "static-1.2274",
  "purchase-motions-api": "static-1.5721",
  "self-service-api": "static-1.10161",
  "signup-constants": "static-1.18698",
  "signup-ui-url-generator": "static-2.7947",
  "usage-tracker-public": "static-1.7064",
  "chatspot-core": "static-1.20905",
  "ContentUtils": "static-1.68099",
  "copilot-toolkit": "static-1.10896",
  "growth-onboarding-feedback-components": "static-1.6499",
  "reactive-lib": "static-1.640",
  "simple-logging-lib": "static-1.2968",
  "commerce-permissions": "static-1.682",
  "customer-data-tracking": "static-1.6801",
  "products-iframe-lib": "static-1.7690",
  "products-ui-components-shared-msw-handlers": "static-1.10155",
  "onboarding-data-sync-lib": "static-1.1820",
  "hubspot-apollo-cache": "static-1.253",
  "calling-error-reporting": "static-1.31224",
  "shared-worker-versioning": "static-1.10954",
  "calling-usage-tracker": "static-1.6457",
  "voice-sms-access-library": "static-1.661",
  "conversations-skeleton-state": "static-1.7167",
  "location-customization-utils-lib": "static-1.8985",
  "crm-pipelines-api-client-types": "static-1.4075",
  "framework-builder-read-service-client": "static-1.3942",
  "framework-data-schema-quick-fetch": "static-1.6696",
  "persist-promise": "static-1.3626",
  "directed-graph": "static-1.854",
  "event-emitter": "static-1.864",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.63",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9856",
  "fsm": "static-1.3651",
  "policy-lib": "static-1.6700",
  "react-tinymce": "static-1.54999",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9919",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54125",
  "tinymce-plugins": "static-1.57239",
  "tinymce-themes": "static-1.56095",
  "growth-onboarding-next-action-components": "static-1.1697",
  "user-context-client": "static-1.4528",
  "nest": "static-1.141",
  "unified-auth-core-lib": "static-1.664",
  "amplitude-session-replay-browser": "static-1.58",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4448",
  "video-embed": "static-1.35495",
  "content-icons-ui": "static-1.2205",
  "social-insights-client-types": "static-1.21850",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4726",
  "integrations-lib": "static-1.15847",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4179",
  "InboxConnectUtils": "static-4.14577",
  "calling-orchestration-schema": "static-1.35438",
  "crm-record-cards-service-types": "static-1.3543",
  "highcharts": "static-8.102",
  "trellis-story-utils": "static-1.4434",
  "storybook-react": "static-1.31",
  "hub-http-contrib": "static-1.2959",
  "tinymce-data": "static-1.40210",
  "ui-addon-sales-email": "static-1.5128",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12284",
  "layout-dnd-utils": "static-1.11259",
  "react-codemirror": "static-1.10540",
  "ui-brand-identity-lib": "static-1.14874",
  "NamespacedHubStyle": "static-2.8999",
  "outpost": "static-1.4108",
  "flux-actions": "static-1.325",
  "integrations-error-boundary-lib": "static-1.13262",
  "integrations-tracking-lib": "static-1.5513",
  "native-integrations-shared-strings": "static-1.7702",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10290",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.383",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68174",
  "layout-data-lib": "static-1.9584",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2926",
  "microsoft-drive-integration-lib": "static-1.78",
  "advanced-menus-core": "static-1.15001",
  "advanced-menus-lib": "static-1.11957",
  "ExportDialog": "static-6.10307",
  "ui-memberships-settings-lib": "static-1.33812",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15000",
  "simple-menus-lib": "static-1.16517"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2019",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.457",
  "data-fetching-client": "/data-fetching-client/static-1.9592",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.428",
  "growth-payments-core": "/growth-payments-core/static-1.25119",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5511",
  "hs-test-utils": "/hs-test-utils/static-1.7929",
  "hub-http": "/hub-http/static-1.6138",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9773",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17995",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11376",
  "I18n": "/I18n/static-7.1605",
  "immutable": "/immutable/static-2.77",
  "jasmine-runner": "/jasmine-runner/static-1.6384",
  "payment-link-components": "/payment-link-components/static-1.23290",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6895",
  "quartz-core": "/quartz-core/static-1.6114",
  "react": "/react/static-7.184",
  "react-colorpicker": "/react-colorpicker/static-2.10126",
  "react-dlb": "/react-dlb/static-1.77",
  "react-utils": "/react-utils/static-2.5276",
  "rich-text-lib": "/rich-text-lib/static-1.19689",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17866",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5514",
  "UIComponents": "/UIComponents/static-3.8323",
  "foundations-assets": "/foundations-assets/static-1.4768",
  "foundations-components": "/foundations-components/static-1.7765",
  "foundations-theming": "/foundations-theming/static-1.4331",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2047",
  "framer-motion": "/framer-motion/static-1.70",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9542",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "portals-platform-lib": "/portals-platform-lib/static-1.733",
  "quartz-config": "/quartz-config/static-1.673",
  "quartz-routing": "/quartz-routing/static-1.325",
  "quick-fetch": "/quick-fetch/static-1.3849",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16576",
  "react-router-dom": "/react-router-dom/static-5.26",
  "rpc-client-utils": "/rpc-client-utils/static-1.4561",
  "sanitize-text": "/sanitize-text/static-1.8061",
  "styled-components": "/styled-components/static-2.88",
  "tanstack-table": "/tanstack-table/static-1.53",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4685",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9461",
  "usage-tracker": "/usage-tracker/static-1.7253",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5670",
  "usage-tracker-core": "/usage-tracker-core/static-1.7103",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3335",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3172",
  "quartz-webpack": "/quartz-webpack/static-1.3119",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.80",
  "customer-data-objects": "/customer-data-objects/static-1.7576",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7842",
  "laboratory-lib": "/laboratory-lib/static-3.7075",
  "onboarding-scopes": "/onboarding-scopes/static-1.6381",
  "ui-addon-opt": "/ui-addon-opt/static-4.8297",
  "HeadJS": "/HeadJS/static-2.736",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3040",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "hs-locale-management": "/hs-locale-management/static-1.17",
  "ts-schema": "/ts-schema/static-1.4011",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7629",
  "cssUtils": "/cssUtils/static-1.772",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9743",
  "HubStyle": "/HubStyle/static-2.11684",
  "knowledge-content-types": "/knowledge-content-types/static-1.8462",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.570",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9803",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11066",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8958",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10065",
  "video-components-external": "/video-components-external/static-1.11003",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4240",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5942",
  "customer-data-properties": "/customer-data-properties/static-1.51250",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18262",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5001",
  "onboarding-tours": "/onboarding-tours/static-1.16447",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8008",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3569",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8967",
  "user-context": "/user-context/static-1.5017",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.820",
  "hubspotter-http": "/hubspotter-http/static-1.4585",
  "icons": "/icons/static-2.639",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.510",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.570",
  "quartz-head": "/quartz-head/static-1.560",
  "quartz-test": "/quartz-test/static-1.570",
  "quartz-tracking": "/quartz-tracking/static-1.274",
  "ui-fonts": "/ui-fonts/static-1.638",
  "usage-tracker-container": "/usage-tracker-container/static-1.7243",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9347",
  "data-token-picker": "/data-token-picker/static-1.16259",
  "FileManagerLib": "/FileManagerLib/static-1.38998",
  "property-translator": "/property-translator/static-1.5322",
  "atom": "/atom/static-1.4987",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "purchase-motions-components": "/purchase-motions-components/static-1.5718",
  "salesImages": "/salesImages/static-1.523",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5248",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.97",
  "ui-images": "/ui-images/static-2.1132",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4035",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "trellis-assets": "/trellis-assets/static-1.1578",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2814",
  "foundations-theming-base": "/foundations-theming-base/static-1.3316",
  "stylex": "/stylex/static-1.30",
  "interframe": "/interframe/static-3.4679",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5667",
  "chirp-fetch": "/chirp-fetch/static-1.1799",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4389",
  "react-flip-move": "/react-flip-move/static-1.68",
  "bender-build-tools": "/bender-build-tools/static-1.3093",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3776",
  "superstore": "/superstore/static-1.4685",
  "feedback-loader": "/feedback-loader/static-1.29145",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8731",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8613",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28307",
  "sassPrefix": "/sassPrefix/static-1.154",
  "react-dnd-compat": "/react-dnd-compat/static-1.4536",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2410",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8085",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4567",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11990",
  "content-media-compositions": "/content-media-compositions/static-2.15997",
  "idb-keyval": "/idb-keyval/static-1.42",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4069",
  "magpie-lib": "/magpie-lib/static-1.5511",
  "magpie-types": "/magpie-types/static-1.4971",
  "media-bridge-lib": "/media-bridge-lib/static-1.18781",
  "video-data-lib": "/video-data-lib/static-1.34661",
  "commerce-products-lib": "/commerce-products-lib/static-1.9216",
  "crm-message-bus": "/crm-message-bus/static-1.42755",
  "growth-data-modal": "/growth-data-modal/static-1.5299",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4794",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4661",
  "calling-global-api": "/calling-global-api/static-1.64176",
  "calling-internal-common": "/calling-internal-common/static-1.31218",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65558",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57852",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3730",
  "crm-links": "/crm-links/static-1.6195",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12938",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9100",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8001",
  "external-options-client-types": "/external-options-client-types/static-1.4091",
  "file-manager-components": "/file-manager-components/static-1.23358",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6791",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.57",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3523",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4156",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.546",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3624",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48460",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3899",
  "property-value-citations": "/property-value-citations/static-1.1864",
  "pulse": "/pulse/static-1.464",
  "smart-property-lib": "/smart-property-lib/static-1.6507",
  "tiered-pricing": "/tiered-pricing/static-1.1038",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10907",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2987",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1669",
  "navigation-components": "/navigation-components/static-1.17724",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.513",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7446",
  "ui-universal-auth": "/ui-universal-auth/static-1.8869",
  "batch-promise": "/batch-promise/static-1.1469",
  "navigation-messaging": "/navigation-messaging/static-1.7051",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17380",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9771",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4939",
  "audio-components": "/audio-components/static-1.5791",
  "FileManagerCore": "/FileManagerCore/static-1.38857",
  "FileManagerImages": "/FileManagerImages/static-1.36509",
  "video-components": "/video-components/static-1.13006",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.790",
  "nav-client-types": "/nav-client-types/static-1.2274",
  "purchase-motions-api": "/purchase-motions-api/static-1.5721",
  "self-service-api": "/self-service-api/static-1.10161",
  "signup-constants": "/signup-constants/static-1.18698",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7947",
  "usage-tracker-public": "/usage-tracker-public/static-1.7064",
  "chatspot-core": "/chatspot-core/static-1.20905",
  "ContentUtils": "/ContentUtils/static-1.68099",
  "copilot-toolkit": "/copilot-toolkit/static-1.10896",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6499",
  "reactive-lib": "/reactive-lib/static-1.640",
  "simple-logging-lib": "/simple-logging-lib/static-1.2968",
  "commerce-permissions": "/commerce-permissions/static-1.682",
  "customer-data-tracking": "/customer-data-tracking/static-1.6801",
  "products-iframe-lib": "/products-iframe-lib/static-1.7690",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10155",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1820",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.253",
  "calling-error-reporting": "/calling-error-reporting/static-1.31224",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10954",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6457",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.661",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7167",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8985",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4075",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3942",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6696",
  "persist-promise": "/persist-promise/static-1.3626",
  "directed-graph": "/directed-graph/static-1.854",
  "event-emitter": "/event-emitter/static-1.864",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.63",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9856",
  "fsm": "/fsm/static-1.3651",
  "policy-lib": "/policy-lib/static-1.6700",
  "react-tinymce": "/react-tinymce/static-1.54999",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9919",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54125",
  "tinymce-plugins": "/tinymce-plugins/static-1.57239",
  "tinymce-themes": "/tinymce-themes/static-1.56095",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1697",
  "user-context-client": "/user-context-client/static-1.4528",
  "nest": "/nest/static-1.141",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.664",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4448",
  "video-embed": "/video-embed/static-1.35495",
  "content-icons-ui": "/content-icons-ui/static-1.2205",
  "social-insights-client-types": "/social-insights-client-types/static-1.21850",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4726",
  "integrations-lib": "/integrations-lib/static-1.15847",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4179",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14577",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35438",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3543",
  "highcharts": "/highcharts/static-8.102",
  "trellis-story-utils": "/trellis-story-utils/static-1.4434",
  "storybook-react": "/storybook-react/static-1.31",
  "hub-http-contrib": "/hub-http-contrib/static-1.2959",
  "tinymce-data": "/tinymce-data/static-1.40210",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5128",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12284",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11259",
  "react-codemirror": "/react-codemirror/static-1.10540",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14874",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8999",
  "outpost": "/outpost/static-1.4108",
  "flux-actions": "/flux-actions/static-1.325",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13262",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5513",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7702",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10290",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.383",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68174",
  "layout-data-lib": "/layout-data-lib/static-1.9584",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2926",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.78",
  "advanced-menus-core": "/advanced-menus-core/static-1.15001",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11957",
  "ExportDialog": "/ExportDialog/static-6.10307",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33812",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15000",
  "simple-menus-lib": "/simple-menus-lib/static-1.16517"
}
};
